import './reset-password-form.scss';

import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import { useTranslation } from '../../../i18n';
import { windowNavigate } from '../../../utils/window.utils';
import { AuthenticationFormErrorCode } from '../../models/auth.model';
import { authenticationFormService } from '../../services/authentication-form.service';

type Props = {
  returnToUrl: string;
  // TODO
  onShowLogin?: () => void;
};

export function ResetPasswordForm({ returnToUrl, onShowLogin }: Props) {
  const actionUrl = '/account/recover';
  const formRef = useRef<HTMLFormElement>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { t } = useTranslation();

  const handleReset = async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = formRef.current!;
    const emailInput = form.querySelector('#email') as HTMLInputElement | null;
    if (!emailInput) {
      setErrorMessage(t('auth.errorEmailNotFound'));
      return false;
    }
    const email = emailInput.value.trim();
    if (!email) {
      setErrorMessage(t('auth.errorEnterEmail'));
      return false;
    }

    const body = new URLSearchParams();
    body.set('form_type', 'recover_customer_password');
    body.set('utf8', '✓');
    body.set('return_to', returnToUrl);
    body.set('email', email);

    setErrorMessage(null);

    await authenticationFormService.submitForm(actionUrl, returnToUrl, form, body, (response) => {
      if (response.type === 'ERROR_CODE') {
        setErrorMessage(response.errorMessage || t('auth.errorResetPassword'));
        windowNavigate(response.redirectUrl);
        if (
          response.errorCode === AuthenticationFormErrorCode.UNKNOWN_ERROR &&
          (response as any).error
        ) {
          setErrorMessage(t('auth.errorResetGeneric'));
          console.error('Login error:', (response as any).error ?? (response as any).response);
        }
      } else if (response.type === 'SUCCESS') {
        if (response.successMessage) {
          setSuccessMessage(response.successMessage);
        } else {
          windowNavigate(response.redirectUrl);
        }
      }
    });

    return false;
  };

  return (
    <form
      id="reset_customer_password"
      accept-charset="UTF-8"
      class="single-reset-password-form"
      onSubmit={handleReset}
      ref={formRef}
    >
      {errorMessage && (
        <div class="single-error-container" dangerouslySetInnerHTML={{ __html: errorMessage }} />
      )}
      {successMessage && (
        <div
          class="single-success-container"
          dangerouslySetInnerHTML={{ __html: successMessage }}
        />
      )}

      <div class="single-input-group">
        <label for="email">{t('auth.email')}</label>
        <input id="email" type="email" name="email" placeholder={t('auth.email')} />
      </div>

      <button class="btn button single-submit-btn" type="submit">
        {t('auth.submit')}
      </button>

      <div class="single-cancel" onClick={() => onShowLogin?.()}>
        <span>{t('common.cancel')}</span>
      </div>
    </form>
  );
}
